(function () {
  const popup = document.querySelector('#shopify-section-sections--20325024891085__1746116803a4524db1');
  const trigger = document.querySelector('.b2b-form-popup-trigger');

  if (trigger && popup) {
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      popup.style.display = 'block';
    });

    document.addEventListener('click', function (e) {
      if (!popup.contains(e.target) && e.target !== trigger) {
        popup.style.display = 'none';
      }
    });

    popup.addEventListener('click', function (e) {
      e.stopPropagation(); // prevent closing when clicking inside the popup
    });
  }
})();

document.addEventListener("DOMContentLoaded", function() {
    const mainImageContainer = document.querySelector('.product_main_img');
    if (!mainImageContainer) return;
    const mainImage = mainImageContainer.querySelector('img'); // Main image element
    const images = document.querySelectorAll('.product_img_single');
    let activeIndex = 0;

    // Function to update the main media (image or video)
    function updateMainMedia(index) {
        const activeElement = images[index];
        if (!activeElement) return;
        const newImage = activeElement.querySelector('img');
        const newVideo = activeElement.querySelector('video');

        // Clear the main image container
        mainImageContainer.innerHTML = '';

        // Check if it's an image or a video and update accordingly
        if (newVideo) {
            // Clone the video and set attributes (autoplay, no controls)
            const clonedVideo = newVideo.cloneNode(true);
            clonedVideo.removeAttribute('controls'); // Ensure no controls are shown
            clonedVideo.play(); // Autoplay the video when it's active
            mainImageContainer.appendChild(clonedVideo);
        } else if (newImage) {
            // Add the image back
            const clonedImage = newImage.cloneNode(true);
            mainImageContainer.appendChild(clonedImage);
        }

        // Remove active class from all and add it to the new active one
        images.forEach(img => img.classList.remove('active'));
        images[index].classList.add('active');
    }

    // Click event for the left arrow
    const arrowLeft = document.querySelector('.product_img_arrow_left');
    if (arrowLeft) arrowLeft.addEventListener('click', function() {
        if (activeIndex > 0) {
            activeIndex--;
        } else {
            activeIndex = images.length - 1; // Loop back to the last image/video
        }
        updateMainMedia(activeIndex);
    });

    // Click event for the right arrow
    const arrowRight = document.querySelector('.product_img_arrow_right');
    if (arrowRight) arrowRight.addEventListener('click', function() {
        if (activeIndex < images.length - 1) {
            activeIndex++;
        } else {
            activeIndex = 0; // Loop back to the first image/video
        }
        updateMainMedia(activeIndex);
    });

    // Click event for each product_img_single
    images.forEach((image, index) => {
        image.addEventListener('click', function() {
            activeIndex = index; // Update the active index
            updateMainMedia(activeIndex);
        });
    });

    // Initialize the main media with the first element (default)
    updateMainMedia(activeIndex);
});





$(document).ready(function(){
	// Mobile Menu
	$('.menu_icon').click(function(){
		$('.menu').slideToggle(200);

		return false
	});

	// Mobile Menu Icon
	$(document).ready(function(){
		$('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').click(function(){
			$(this).toggleClass('open');
		});
	});

	// Products Carousel
	$('.related_products_carousel').owlCarousel({
		loop:true,
		nav:true,
		dots:false,
		autoplay:false,
		margin: 20,
		responsive : {
		    0 : {
		        items:1,
				dots:true,
		    },
		    480 : {
		        items:1,
				dots:true,
		    },
		    768 : {
		        items:2,
				dots:true,
		    },
		    992 : {
		        items:3,
				dots:false,
		    },
		    1200 : {
		        items:4,
				dots:false,
		    }
		}
	});
	$( ".owl-prev").html('<i class="fa fa-chevron-left"></i>');
	$( ".owl-next").html('<i class="fa fa-chevron-right"></i>');


	// Cylinders Page Filter
	$('.cylinders_products_filter_title a').click(function(){
		$('.cylinders_products_filter').slideToggle();

		return false
	});




});







	// Double Range
	window.onload = function () {
	  slideOne();
	  slideTwo();
	};

	let sliderOne = document.getElementById("slider-1");
	let sliderTwo = document.getElementById("slider-2");
	let displayValOne = document.getElementById("range1");
	let displayValTwo = document.getElementById("range2");
	let minGap = 0;
	let sliderTrack = document.querySelector(".slider-track");
	let sliderMaxValue = sliderOne ? sliderOne.max : 0;

	function slideOne() {
	  if (!sliderOne || !sliderTwo || !displayValOne) return;
	  if (parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap) {
	    sliderOne.value = parseInt(sliderTwo.value) - minGap;
	  }
	  displayValOne.textContent = sliderOne.value;
	  fillColor();
	}
	function slideTwo() {
	  if (!sliderOne || !sliderTwo || !displayValTwo) return;
	  if (parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap) {
	    sliderTwo.value = parseInt(sliderOne.value) + minGap;
	  }
	  displayValTwo.textContent = sliderTwo.value;
	  fillColor();
	}
	function fillColor() {
	  if (!sliderOne || !sliderTwo || !sliderTrack) return;
	  percent1 = (sliderOne.value / sliderMaxValue) * 100;
	  percent2 = (sliderTwo.value / sliderMaxValue) * 100;
	  sliderTrack.style.background = `linear-gradient(to right, #dadae5 ${percent1}% , #3264fe ${percent1}% , #3264fe ${percent2}%, #dadae5 ${percent2}%)`;
	}


